var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDealIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.67 17.29 17.29.672a2.29 2.29 0 0 1 2.02-.635l9.17 1.633a2.29 2.29 0 0 1 1.852 1.853l1.632 9.17c.131.736-.106 1.49-.635 2.019L14.71 31.329a2.285 2.285 0 0 1-1.618.67 2.289 2.289 0 0 1-1.62-.67L.668 20.525a2.287 2.287 0 0 1 .003-3.234Zm22.702-8.635a2.327 2.327 0 1 0 3.266-3.316 2.327 2.327 0 0 0-3.266 3.316Z",
    fill: "#FFDCA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.293 10.335-.07.071.07.071 3.29 3.29c.237.237.495.365.774.365h.003c.277-.008.536-.142.775-.38.11-.11.218-.246.326-.405.108-.16.19-.317.244-.47l.025-.072-.063-.044-.648-.454-.106-.074-.045.122a1.107 1.107 0 0 1-.242.38c-.06.06-.117.083-.17.084-.05-.003-.135-.045-.261-.171l-3.037-3.036-.07-.071-.07.07-.725.724ZM14.905 12.938l-.049.05.03.063 2.42 5.252.06.13.101-.101.768-.768.049-.049-.03-.063-.575-1.245 1.241-1.24 1.25.57.063.029.05-.05.766-.767.102-.1-.13-.061-5.247-2.426-.063-.03-.05.05-.756.756Zm2.283 2.43-.844-1.744 1.726.86-.882.884ZM16.605 17.746l-.07-.07-.071.07-1.848 1.847-.858-.858 1.545-1.545.07-.07-.07-.071-.605-.605-.071-.071-.07.07-1.546 1.545-.782-.782 1.799-1.799.07-.07-.07-.071-.654-.654-.07-.07-.071.07-2.616 2.615-.07.07.07.072 3.837 3.836.07.07.071-.07 2.664-2.664.07-.07-.07-.071-.654-.654ZM10.586 25.072l.07.07.071-.07 1.394-1.394c.396-.395.66-.822.788-1.28a2.42 2.42 0 0 0-.011-1.386c-.14-.462-.41-.892-.809-1.29a3.162 3.162 0 0 0-1.21-.775 2.37 2.37 0 0 0-1.38-.062c-.476.113-.928.388-1.355.815L6.75 21.094l-.07.071.07.07 3.836 3.837Zm-.141-4.953c.261.092.512.255.752.495.232.233.396.484.495.753.098.26.12.52.066.782-.056.255-.198.5-.432.734l-.577.577-2.388-2.387.578-.578c.23-.23.474-.37.729-.426h.001c.254-.06.512-.045.776.05Z",
    fill: "#483424",
    stroke: "#483525",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(-1 0 0 1 32 0)",
    d: "M0 0h32v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealIco);
export default __webpack_public_path__ + "static/media/deal_ico.c695a79f34c9f4c0ed3f410d8a137267.svg";
export { ForwardRef as ReactComponent };